import type { FaireProductEntity } from "../../entity_types/product";

export const p_vtk3bjumnj: FaireProductEntity = {
  token: "p_vtk3bjumnj",
  type: "product",
  name: "12PCS - Pocket Hand Sanitizer Spray",
  brandToken: "b_c3xmn96nkh",
  brandName: "Sensibling Corp.",
  imageUrl:
    "https://cdn.faire.com/fastly/3f966b5281110345fd66b9daa913f6e4b0b6768e0347b317789c0b2461007e46.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f5dd1ebf94acca3a5b3016f66fccd97f7101a0383300efadf1cfd47ab6a3d6b4.jpeg",
    "https://cdn.faire.com/fastly/b117126f2aa2d6679ab7b7e71582b7fe95034cb5d2396cb4abb8e5d56da1a354.jpeg",
    "https://cdn.faire.com/fastly/eaff27572c6357fecdf063a0135a8d8304b613b5afba7edefc05a275bee89d43.jpeg",
  ],
  priceDollars: 2.07,
  description:
    '• Size : 2.25" X 4" X 0.7"\n• A slim pocket sanitizer spray card set made for easy, on-the-go hygiene. Compact design fits bags or wallets, ideal for travel, school, events, party favors, or daily use, offering fast cleanup and convenient sharing wherever you go.',
  tags: [],
  msrpDollars: 4.14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:54:55.497Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
